import React, { useRef, useState } from 'react'
import { makeStyles } from '@material-ui/styles'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import { ButtonBase } from '@material-ui/core'
import { createIdForTest } from 'utils/testingUtils.js'

const useStyles = makeStyles(theme => ({
  sidebarItemRoot: {
    display: 'flex',
    position: 'relative',
    padding: '2px 5px 2px 5px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    lineHeight: 0.8,
    cursor: 'pointer'
  },
  icon: {
    padding: '10px 11px 10px 10px'
  },
  title: {
    minWidth: 150,
    userSelect: 'none'
  },
  selectedTitle: {
    color: 'var(--text-color-3)'
  },
  disabled: {
    color: '#9BA3B2'
  }
}))

const SidebarItem = ({ icon, title, isActive = false, isDisabled, disabledHoverComponent, onClick }) => {
  const classes = useStyles()
  const sidebarItemRef = useRef()
  const [isHovered, setIsHovered] = useState(false)

  return (
    <>
      <ButtonBase
        ref={sidebarItemRef}
        className={classes.sidebarItemRoot}
        onClick={() => {
          if (isDisabled) {
            return
          }
          onClick()
        }}
        id={createIdForTest({ componentId: 'patient-sidebar', title: title })}
        onMouseEnter={() => {
          setIsHovered(true)
        }}
        onMouseLeave={() => {
          setIsHovered(false)
        }}
      >
        <div className={classes.icon}>
          {React.createElement(icon, {
            isActive: isActive || isHovered,
            isDisabled
          })}
        </div>
        <DazzedParagraph14
          strong
          className={[
            classes.title,
            !isDisabled && (isActive || isHovered) ? classes.selectedTitle : '',
            isDisabled ? classes.disabled : ''
          ].join(' ')}
        >
          {title}
        </DazzedParagraph14>
      </ButtonBase>
      {isDisabled && React.createElement(disabledHoverComponent, { itemRef: sidebarItemRef })}
    </>
  )
}

export default SidebarItem
